import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import firebase from '../firebase';
import '../Pages/common.scss';

const RequestPasswordReset = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const history = useHistory();
  const location = useLocation();

  // Pre-fill email if passed from signin page
  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    try {
      setIsLoading(true);
      setError('');
      
      // Use custom action URL settings to avoid deprecated Firebase endpoints
      const actionCodeSettings = {
        url: `${window.location.origin}/reset-password`,
        handleCodeInApp: false,
      };
      
      await firebase.auth().sendPasswordResetEmail(email, actionCodeSettings);
      setSuccess(true);
      
      // Redirect back to signin after 3 seconds
      setTimeout(() => {
        history.push('/signin');
      }, 3000);
      
    } catch (error) {
      console.error('Password reset error:', error);
      if (error.code === 'auth/user-not-found') {
        setError('No account found with this email address.');
      } else if (error.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else {
        setError('Failed to send reset email. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <h2>Check Your Email</h2>
          <p>We've sent a password reset link to:</p>
          <p className="email-display">{email}</p>
          <p>Click the link in the email to reset your password.</p>
          <p className="redirect-text">Redirecting to sign in page...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Reset Your Password</h2>
        <p className="description">
          Enter your email address and we'll send you a link to reset your password.
        </p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        
        <div className="auth-links">
          <button 
            onClick={() => history.push('/signin')}
            className="link-btn"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
